import React from 'react'
import PropTypes from 'prop-types'
import { useFilterValue, useWillConstrain } from '@morningtrain/react-filters'
import { ResourceSelector } from 'support/fields'
import withTranslations from 'support/hoc/withTranslations'

function ResourceFilter (props) {
  const {
    name,
    namespace,
    resourceName,
    optionsKey,
    label,
    placeholder,
    defaultValue,
    operationName = 'index',
    onChange = null,
  } = props

  const [value, setValue] = useFilterValue(name)

  useWillConstrain(name, value)

  const handleChange = (value) => {
    if (typeof onChange === 'function') {
      onChange(value)
    }

    setValue(value)
  }

  React.useEffect(() => {
    if (typeof defaultValue !== 'undefined') {
      setValue(defaultValue)
    }
  }, [])

  return (
    <ResourceSelector
      {...props}
      label={label}
      placeholder={placeholder}
      optionsKey={optionsKey}
      namespace={namespace}
      resourceName={resourceName}
      operationName={operationName}
      defaultValue={value}
      onChange={(e) => handleChange(e)}
    >
      {props.children}
    </ResourceSelector>
  )
}

ResourceFilter.propTypes = {
  name: PropTypes.string.isRequired,
  resourceName: PropTypes.string.isRequired,
  label: PropTypes.any,
  namespace: PropTypes.string,
  optionsKey: PropTypes.string,
  placeholder: PropTypes.string,
  operationName: PropTypes.string
}

export default withTranslations(ResourceFilter)
